module.exports = __webpack_public_path__ + "static/media/PREVENCION_INFO.5eb2b4c6.jpg";